import React from 'react';
import CommonConst from '../../../common/Const';
import { SingleInputPopup } from './../../../common/popup';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { connect } from 'react-redux';
import { REDUCER_NAME, actionSaveLayoutPopup } from './../reducer';
import EventEmitter, {
  CHARTING_SCREEN_SHOT_READY,
  GET_CHARTING_SCREEN_SHOT,
} from '../../../helpers/EventEmitter';

class SaveLayoutPopup extends React.Component {
  saveLayout = async (isApply, name) => {
    const { confirm } = this.props;
    if (!isApply) {
      confirm(isApply, name);
      return;
    }
    EventEmitter.dispatch(GET_CHARTING_SCREEN_SHOT);
    const chartingImages = await this.getChartingImages();
    confirm(isApply, name, chartingImages);
  };

  getChartingImages = () => {
    const { countListComponent } = this.props;
    return new Promise(resolve => {
      const countImage = countListComponent[CommonConst.listComponent.Charting];
      if (!countImage) {
        resolve(null);
        return;
      }
      let images = {};
      const onChartingScreenShotReady = data => {
        images = {
          ...images,
          ...data,
        };
        if (Object.keys(images).length === countImage) {
          EventEmitter.unsubscribe(
            CHARTING_SCREEN_SHOT_READY,
            onChartingScreenShotReady,
          );
          resolve(images);
        }
      };
      EventEmitter.subscribe(
        CHARTING_SCREEN_SHOT_READY,
        onChartingScreenShotReady,
      );
    });
  };

  render() {
    const { isShow } = this.props;
    return (
      <div className="save-workspace">
        <SingleInputPopup
          isShow={isShow}
          title={'layout.createWorkspace'}
          placeHolder={'layout.createWorkspace'}
          confirm={this.saveLayout}
          isCheckValidate={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isShow: state[REDUCER_NAME].saveLayout.isShowPopup,
    countListComponent: state[COMMON_REDUCER_NAME].countListComponent,
  };
};

const mapDispatchToProps = {
  confirm: actionSaveLayoutPopup,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SaveLayoutPopup);
